(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["brume-achat"] && !Shopify.designMode) return;
  try {
    (function () {
    function run() {
      document.querySelectorAll('[data-brume-end]').forEach(function (el) {
        var end = new Date(el.getAttribute('data-brume-end') + 'T23:59:59');
        if (isNaN(end)) return;
        var lbl = el.querySelector('[data-brume-endlabel]');
        if (lbl) lbl.textContent = end.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
        function tick() {
          var ms = Math.max(0, end - new Date());
          el.querySelector('[data-brume-d]').textContent = Math.floor(ms / 864e5);
          el.querySelector('[data-brume-h]').textContent = String(Math.floor(ms / 36e5) % 24).padStart(2, '0');
          el.querySelector('[data-brume-m]').textContent = String(Math.floor(ms / 6e4) % 60).padStart(2, '0');
          if (ms === 0) el.style.display = 'none';
        }
        tick(); clearInterval(el._brumeT); el._brumeT = setInterval(tick, 30000);
      });
      document.querySelectorAll('[data-brume-cutoff]').forEach(function (el) {
        var h = parseInt(el.getAttribute('data-brume-cutoff'), 10), now = new Date(), cut = new Date(now);
        cut.setHours(h, 0, 0, 0);
        var msg = el.querySelector('[data-brume-shipmsg]'), wd = now.getDay() !== 0 && now.getDay() !== 6;
        if (!msg) return;
        if (wd && now < cut) {
          var left = cut - now;
          msg.textContent = 'Commande dans les ' + Math.floor(left / 36e5) + ' h ' + (Math.floor(left / 6e4) % 60) + ' min : expédiée aujourd\u2019hui';
        } else {
          msg.textContent = 'Commande maintenant : expédiée au prochain jour ouvré';
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brume-offres"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__brumeOffres) return;
    window.__brumeOffres = true;
    function setActive(root, id) {
      root.querySelectorAll('.brume-oc').forEach(function (b) {
        var on = b.getAttribute('data-variant-id') === String(id);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.brume-oc');
      if (!btn || btn.disabled) return;
      var root = btn.closest('[data-brume-offres]');
      var id = btn.getAttribute('data-variant-id');
      setActive(root, id);
      var scope = root.closest('.shopify-section') || document;
      var input = scope.querySelector('variant-picker input[data-variant-id="' + id + '"]');
      if (input) { if (!input.checked) input.click(); }
      else { var u = new URL(window.location.href); u.searchParams.set('variant', id); window.location.href = u.toString(); }
    });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('variant-picker input[data-variant-id]') || !t.checked) return;
      var scope = t.closest('.shopify-section') || document;
      scope.querySelectorAll('[data-brume-offres]').forEach(function (root) { setActive(root, t.getAttribute('data-variant-id')); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
